import type { FC } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Box } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type { IAppsAndroidIdentifierFilter } from "../../../../types/androidFiltersDto";
import AppIdentifierBulkAdd from "../AppIdentifierBulkAdd/AppIdentifierBulkAdd";
import { StyledFilterHeading } from "../styles";
import { TextField } from "../TextField/TextField";
import { AppsIdentifiers } from "../types";
import { parseInputValue } from "../utils";

export const AppsAndroidIdentifiersFilter: FC<IFilterViewBaseModelProps<IAppsAndroidIdentifierFilter>> = ({
    onFilterUpdate,
    value,
}) => {
    const { translate } = useTranslate();

    const handleUpdate = (newValue: string[]) => {
        onFilterUpdate({ packageNames: Array.from(new Set([...(value?.packageNames ?? []), ...newValue])) });
    };

    const handleTextFieldUpdate = (newValue: string) => {
        handleUpdate(parseInputValue(newValue));
    };

    const validate = (inputValue: string) => {
        const regExp = /^[a-z]([a-z0-9_]*\.)+[a-z0-9_]+$/;
        return parseInputValue(inputValue).every((v) => regExp.test(v));
    };

    return (
        <Box width="263px">
            <StyledFilterHeading>{translate("si.find_apps.filters.identifier.android.title")}</StyledFilterHeading>

            <TextField
                label={translate("si.find_apps.filters.identifier.android.label")}
                placeholder={translate("si.find_apps.filters.identifier.android.placeholder")}
                validate={validate}
                onUpdate={handleTextFieldUpdate}
            />
            <AppIdentifierBulkAdd
                appIdentifierType={AppsIdentifiers.PackageName}
                onUpdate={handleUpdate}
            />
        </Box>
    );
};
